import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Partenaires.css';

const TECH_STACK = [
  { name: "React.js", emoji: "⚛️", desc: "Interfaces web modernes, performantes et maintenables." },
  { name: "React Native", emoji: "📱", desc: "Applications iOS et Android depuis un seul code source." },
  { name: "Node.js", emoji: "🟩", desc: "API rapides et scalables pour nos backends." },
  { name: "MongoDB", emoji: "🍃", desc: "Base de donnees flexible adaptee aux projets digitaux africains." },
  { name: "Docker", emoji: "🐳", desc: "Conteneurisation pour des deploiements reproductibles." },
  { name: "GitHub", emoji: "🐙", desc: "Versionning et collaboration sur l'ensemble de nos projets." },
  { name: "Render", emoji: "☁️", desc: "Hebergement cloud fiable pour nos APIs et applications." },
  { name: "Orange Money API", emoji: "🟠", desc: "Integration de paiement mobile pour le marche ivoirien." },
  { name: "Wave API", emoji: "💙", desc: "Paiement instantane par Wave pour vos clients." },
  { name: "Nginx", emoji: "🌐", desc: "Serveur web et reverse proxy pour nos deployments en production." },
];

const PARTNER_TYPES = [
  { icon: "🤝", title: "Partenaires revendeurs", desc: "Vous etes consultant ou agence de communication ? Revendez nos solutions a vos clients avec une commission attractive. Pas de limite geographique." },
  { icon: "💼", title: "Partenaires apporteurs d'affaires", desc: "Recommandez-nous un client et recevez une remuneration sur chaque contrat signe. Simple, transparent, sans engagement." },
  { icon: "🏢", title: "Partenaires entreprises", desc: "Vous etes une PME ou ONG qui cherche un prestataire technique fiable sur le long terme ? On propose des accords cadres adaptes." },
];

export default function Partenaires() {
  return (
    <>
      <Helmet>
        <title>Partenaires — NEXUS SOLUTIONS</title>
        <meta name="description" content="Decouvrez l'ecosysteme technologique et les partenariats de NEXUS SOLUTIONS, agence digitale a Abidjan." />
      </Helmet>

      <div className="partners-hero">
        <div className="partners-hero__label">Ecosysteme</div>
        <h1 className="partners-hero__title">
          Nos technologies<br />
          <span>et partenariats</span>
        </h1>
        <p className="partners-hero__sub">
          On travaille avec les meilleurs outils du marche, adaptes au contexte ivoirien et africain.
        </p>
      </div>

      {/* Stack technologique */}
      <section className="partners-tech">
        <div className="partners-tech__inner">
          <h2 className="partners-section-title">Notre stack technologique</h2>
          <p className="partners-section-sub">Les technologies que nous maitrisons et utilisons sur chaque projet.</p>
          <div className="partners-tech__grid">
            {TECH_STACK.map(t => (
              <div className="partners-tech__card" key={t.name}>
                <span className="partners-tech__emoji">{t.emoji}</span>
                <div className="partners-tech__name">{t.name}</div>
                <p className="partners-tech__desc">{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Types de partenariats */}
      <section className="partners-types">
        <div className="partners-types__inner">
          <h2 className="partners-section-title">Devenir partenaire</h2>
          <p className="partners-section-sub">
            Plusieurs formes de collaboration sont possibles selon votre profil.
          </p>
          <div className="partners-types__grid">
            {PARTNER_TYPES.map(p => (
              <div className="partners-types__card" key={p.title}>
                <span className="partners-types__icon">{p.icon}</span>
                <h3 className="partners-types__title">{p.title}</h3>
                <p className="partners-types__desc">{p.desc}</p>
              </div>
            ))}
          </div>
          <div className="partners-types__cta">
            <p>Interessé par un partenariat ?</p>
            <Link to="/contact" className="partners-types__btn">Parlons-en</Link>
            <a
              href="mailto:contact@nxs-solutions.com"
              className="partners-types__btn partners-types__btn--wa"
            >
              Nous ecrire
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
